var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 4.76875V3.125C10.9375 1.875 10.3125 1.25 9.0625 1.25H5.9375C4.6875 1.25 4.0625 1.875 4.0625 3.125V4.725",
    fill: "#DFFFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 4.76875V3.125C10.9375 1.875 10.3125 1.25 9.0625 1.25H5.9375C4.6875 1.25 4.0625 1.875 4.0625 3.125V4.725",
    stroke: "#26AF00",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6626 6.88752V9.99377C2.6626 11.1313 2.6626 11.1313 3.7376 11.8563L6.69385 13.5625C7.1376 13.8188 7.8626 13.8188 8.30635 13.5625L11.2626 11.8563C12.3376 11.1313 12.3376 11.1313 12.3376 9.99377V6.88752C12.3376 5.75002 12.3376 5.75002 11.2626 5.02502L8.30635 3.31877C7.8626 3.06252 7.1376 3.06252 6.69385 3.31877L3.7376 5.02502C2.6626 5.75002 2.6626 5.75002 2.6626 6.88752Z",
    fill: "white",
    stroke: "#26AF00",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98169 6.49018L8.41696 7.1698C8.48568 7.27671 8.63841 7.38361 8.75295 7.41416L9.53185 7.6127C10.0129 7.73488 10.1427 8.14724 9.82966 8.52905L9.31803 9.14758C9.24167 9.24685 9.18058 9.42248 9.18822 9.54466L9.23403 10.3465C9.26458 10.8428 8.91331 11.0948 8.45514 10.9115L7.70679 10.6137C7.59225 10.5679 7.40134 10.5679 7.2868 10.6137L6.53845 10.9115C6.08027 11.0948 5.72901 10.8352 5.75955 10.3465L5.80537 9.54466C5.81301 9.42248 5.75192 9.23922 5.67555 9.14758L5.16393 8.52905C4.85084 8.14724 4.98066 7.73488 5.46174 7.6127L6.24063 7.41416C6.36281 7.38361 6.51554 7.26907 6.57663 7.1698L7.01189 6.49018C7.2868 6.07782 7.71443 6.07782 7.98169 6.49018Z",
    fill: "#DFFFD4",
    stroke: "#26AF00",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.b5262ca9ed35624405d4c8935b51512e.svg";
export { ForwardRef as ReactComponent };